const logoutUaePassUrl = (uaePassconfiguration) => {
    let uaePassEndpoint = uaePassconfiguration.uaePassLogOutEndPoint;
    let redirectURI = uaePassconfiguration.redirectURL;

    let uaePasslogoutURL =
      uaePassEndpoint + "redirect_uri=" + redirectURI.replace("Account/UAEPassRedirect","");

    //https://stg-id.uaepass.ae/idshub/authorize?redirect_uri=http://213.42.234.23:8902/Account/UAEPassRedirect&client_id=sandbox_stage&response_type=code&state=ShNP22hyl1jUU2RGjTRkpg==&scope=urn:uae:digitalid:profile:general&acr_values=urn:safelayer:tws:policies:authentication:level:low&ui_locales=en-us
    return uaePasslogoutURL;
  };
  export default logoutUaePassUrl;